import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Head from '@/components/base/Head';
import { articles } from '@/mocks/data';

const articleDetailImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=A%20luxurious%20hotel%20entrance%20at%20night%20with%20paparazzi-style%20photography%2C%20dramatic%20lighting%2C%20blurred%20figure%20walking%20in%2C%20cinematic%20composition%2C%20warm%20amber%20street%20lights%2C%20mysterious%20atmosphere%2C%20editorial%20magazine%20quality%2C%20high%20contrast%20shadows&width=1200&height=600&seq=art-detail-01&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=A%20modern%20live%20streaming%20studio%20setup%20with%20professional%20lighting%20equipment%2C%20smartphone%20on%20tripod%2C%20beauty%20products%20scattered%20on%20table%2C%20slightly%20chaotic%20atmosphere%2C%20warm%20indoor%20lighting%2C%20documentary%20style&width=1200&height=600&seq=art-detail-02&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Two%20smartphones%20displaying%20social%20media%20profiles%20with%20unfollow%20buttons%2C%20soft%20moody%20lighting%2C%20melancholy%20atmosphere%2C%20editorial%20photography%2C%20warm%20desaturated%20tones%2C%20intimate%20composition&width=1200&height=600&seq=art-detail-03&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20TV%20studio%20with%20production%20equipment%2C%20lighting%20rigs%2C%20empty%20stage%20seats%2C%20dramatic%20spotlight%2C%20moody%20atmosphere%2C%20cinematic%20documentary%20style&width=1200&height=600&seq=art-detail-04&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=An%20upscale%20private%20dining%20room%20in%20a%20high-end%20Chinese%20restaurant%2C%20round%20table%20with%20dishes%2C%20dim%20warm%20lighting%2C%20suspenseful%20atmosphere%2C%20cinematic%20photography%2C%20rich%20amber%20tones&width=1200&height=600&seq=art-detail-05&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=Split%20composition%20showing%20before%20and%20after%20concept%2C%20soft%20beauty%20clinic%20aesthetic%2C%20diffused%20lighting%2C%20elegant%20but%20dramatic%20comparison%2C%20editorial%20magazine%20style%2C%20warm%20peachy%20tones&width=1200&height=600&seq=art-detail-06&orientation=landscape',
  7: 'https://readdy.ai/api/search-image?query=Modern%20office%20workspace%20with%20multiple%20computer%20screens%20showing%20social%20media%20dashboards%2C%20scattered%20documents%2C%20dim%20desk%20lamp%2C%20moody%20atmosphere%2C%20documentary%20style%2C%20late%20night%20working&width=1200&height=600&seq=art-detail-07&orientation=landscape',
  8: 'https://readdy.ai/api/search-image?query=Billboard%20being%20changed%20with%20brand%20advertisement%2C%20workers%20on%20ladder%2C%20urban%20street%20scene%2C%20dramatic%20sky%2C%20editorial%20photography%2C%20cinematic%20composition%2C%20warm%20sunset%20lighting&width=1200&height=600&seq=art-detail-08&orientation=landscape',
  9: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20bright%20stage%20lights%2C%20empty%20chairs%2C%20microphone%20on%20floor%2C%20dramatic%20tension%20atmosphere%2C%20cinematic%20lighting%20with%20strong%20contrast&width=1200&height=600&seq=art-detail-09&orientation=landscape',
  10: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20building%20exterior%20at%20dusk%2C%20dramatic%20sky%2C%20somber%20mood%2C%20reflective%20glass%20windows%2C%20urban%20landscape%2C%20editorial%20journalism%20photography&width=1200&height=600&seq=art-detail-10&orientation=landscape',
  11: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20film%20set%20with%20traditional%20costumes%20and%20props%2C%20behind%20scenes%20chaos%2C%20dramatic%20confrontation%2C%20cinematic%20lighting%2C%20warm%20sunset%20backlight&width=1200&height=600&seq=art-detail-11&orientation=landscape',
  12: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20video%20editing%20timeline%20with%20visible%20cuts%2C%20dramatic%20reveal%20moment%2C%20moody%20lighting%2C%20modern%20digital%20aesthetic%2C%20warm%20amber%20and%20cool%20contrast&width=1200&height=600&seq=art-detail-12&orientation=landscape',
};

const articleContentMap: Record<number, string> = {
  1: `据知情人士透露，某当红顶流男星近日被拍到深夜与一名神秘女子前后进入某五星级酒店，直至次日清晨才分别离开，引发粉丝和网友的广泛讨论。

<h2>事件经过</h2>

<p>据目击者称，当晚约11点左右，该男星驾驶一辆黑色商务车抵达酒店地下停车场。约半小时后，一名身着黑色连衣裙、戴着口罩和墨镜的女子从同一入口进入酒店大堂。两人先后进入电梯前往同一楼层。</p>

<p>直到第二天早上7点过后，该男星才独自驾车离开酒店。而那名神秘女子则在约8点左右由一辆网约车接走。整个过程被隐藏在附近的娱乐记者全程拍摄。</p>

<h2>身份猜测</h2>

<p>消息传出后，网友们立即展开了对该神秘女子身份的猜测。有人根据身形和发型推测是某新晋女演员，也有人认为是圈外素人。更有自称知情人士的网友爆料称两人已秘密交往半年有余。</p>

<p>该男星的经纪公司截至目前尚未对此事作出任何回应，其官方社交账号也未更新任何动态。</p>

<h2>粉丝反应</h2>

<p>此事在粉丝群体中引发了截然不同的反应。一部分粉丝表示支持偶像的私人生活，认为"艺人也是人，有恋爱的权利"；另一部分粉丝则表达了不满，认为偶像应该对粉丝坦诚相待。</p>

<p>也有不少路人网友表示："吃瓜群众就静静看着，反正也不关我们的事。"</p>`,
  2: `<p>拥有千万粉丝的某带货主播在近日直播中售卖的高端护肤品被消费者质疑为假货，品牌方已发表声明否认与该主播有合作关系，事件正在持续发酵中。</p>

<h2>事件起因</h2>

<p>上周末的一场直播中，该主播以"全网最低价"为卖点，推荐了一款据称是某国际知名品牌的高端精华液，售价仅为官方价格的十分之一。直播结束后，有购买该产品的消费者在社交平台晒出对比图，质疑产品质地、气味和包装与正品存在明显差异。</p>

<h2>品牌方回应</h2>

<p>事件发酵后，该国际品牌的中国区官方账号发布声明称："近期发现有不法商家冒用我司品牌名义销售假冒产品，我司未授权任何直播带货渠道销售我司产品，请广大消费者通过官方渠道购买。"声明虽未点名具体主播，但发布时机和内容指向性极强。</p>

<h2>消费者维权</h2>

<p>目前已有超过500名消费者组成维权群，要求该主播公开道歉并退一赔三。部分消费者已向市场监管部门投诉举报。有法律人士分析，如果假货指控属实，该主播可能面临严重的法律后果。</p>

<h2>主播回应</h2>

<p>该主播在最新的直播中表示："我们所有商品都有正规渠道来源，如果确实存在问题，我们一定会负责到底。"但其并未提供具体的供货渠道证明文件。</p>`,
  3: `<p>曾被誉为娱乐圈模范夫妻的某明星夫妇近期被网友发现在社交平台互相取关，且已数月无公开互动，婚变传闻甚嚣尘上。</p>

<h2>蛛丝马迹</h2>

<p>有细心的网友发现，这对明星夫妇在各大社交平台上已经互相取消了关注。更令人玩味的是，两人的最后一张合照发布于三个月前，此后各自的动态中再也没有出现过对方的身影。</p>

<p>在最近一次公开活动中，当记者问及对方的近况时，其中一方以"最近工作比较忙"为借口匆匆带过，并未给出正面回应。</p>

<h2>过往回顾</h2>

<p>这对明星夫妇于五年前在一部热播剧的拍摄中相识，随后公开恋情并于次年举办了一场盛大的婚礼，当时被誉为"金童玉女""神仙眷侣"。婚后两人育有一子一女，一直以恩爱形象示人。</p>

<h2>网友态度</h2>

<p>对于婚变传闻，网友们的态度出乎意料地理性。不少人表示："明星也是普通人，感情出了问题很正常""如果真的走不下去了，和平分手对大家都好"。但也有忠实粉丝表示不相信："没有实锤的一切都只是猜测"。</p>
`,
  4: `<p>一位自称曾参与某大型选秀节目制作的工作人员匿名爆料，称节目中的淘汰名单早在录制前就已由导演组和赞助商共同敲定。</p>

<h2>爆料内容</h2>

<p>该匿名人士在社交平台发布长文称："我参与了三季的制作，每一季的海选看起来很真实，但到了后期，谁走谁留都是提前定好的。有些选手明明表现很好，但因为背后的经纪公司不够强势，或者赞助商不满意，就被安排淘汰了。"</p>

<p>他进一步透露，节目组会在录制前召开"淘汰讨论会"，导演、制片人和赞助商代表会共同商议下一轮的淘汰名单。选手在台上的表现只是"配合演出"而已。</p>

<h2>行业人士看法</h2>

<p>一位曾参与多档选秀节目的资深制作人在接受采访时表示："这其实在业内已经不是什么秘密了。选秀节目本质上是一档综艺，综艺就需要有剧本。但这不代表所有的淘汰都是内定的，有时候选手的临场表现确实会影响最终结果。"</p>

<h2>观众反应</h2>

<p>这则爆料让许多曾经为自己喜欢的选手被淘汰而痛心的观众感到"恍然大悟"。有网友愤怒地表示："我们的投票和应援都是真金白银，结果你们在后台就把名单定好了？"也有理性观众认为："选秀综艺本身就是娱乐，认真就输了。"</p>`,
  5: `<p>一段疑似某知名科技公司创始人在私人饭局上的录音近日在网络流传，其中涉及对竞争对手的激烈言论和对行业未来的大胆预测，引发科技圈震动。</p>

<h2>录音内容</h2>

<p>在这段长约40分钟的录音中，一个被网友辨认出的声音对多家竞争对手进行了尖锐的评论，其中不乏直接的人身攻击和业务评判。该声音还预测了未来三年的行业走向，提出了一些颇具争议的商业策略。</p>

<p>录音中还涉及了对于监管政策的讨论，部分言论被指存在合规风险。</p>

<h2>各方反应</h2>

<p>录音曝光后，被点名的多家公司反应不一。有的保持沉默，有的通过官方渠道发布了"不予置评"的声明，还有一家公司直接在官方账号发文回怼："真正的强者靠实力说话，而不是靠饭局上的酒话。"</p>

<p>行业协会已表示将"密切关注此事"。</p>`,
  6: `<p>一组疑似某知名女星整容前后的对比照片在社交平台被疯狂转发，照片中面部轮廓变化明显，引发网友热议。</p>

<h2>对比照片</h2>

<p>这组照片共包含五张对比图，分别展示了该女星不同时期的正面照、侧面照和素颜照。从早期照片来看，该女星的脸型较为圆润，鼻梁相对扁平，眼部轮廓也不太明显。</p>

<p>而近期的照片中，她的脸型明显变得更加精致，下巴线条更加尖锐，鼻梁高挺，眼睛也显得更大更有神。照片对比之强烈，让不少网友直呼"认不出"。</p>

<h2>粉丝辩护</h2>

<p>该女星的粉丝们迅速组织了"反击"，指出照片对比存在严重的选取偏差——早期的照片大多是在光线不好、角度不佳的情况下拍摄的生活照，而近期的照片则都是精修过的活动照，完全不具备可比性。</p>

<p>还有粉丝找出了该女星各个时期的"原图"，试图证明她的容貌变化是"自然长开"和化妆技术进步的结果。</p>

<h2>理性看待</h2>

<p>有医美行业的专业人士分析称，从容貌变化来看，即便有医美痕迹也是微调级别的，远没有到"换头"的程度。该人士建议广大网友理性看待明星的容貌变化，不要过度解读。</p>`,
};

const articleDefaultContent = `<p>本文正在持续跟进中，最新信息将第一时间更新。请关注黑料吃瓜网获取更多详情。</p>`;

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const article = articles.find((a) => a.id === Number(id));

  if (!article) {
    return (
      <>
        <Navbar />
        <div className="pt-20 min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-heading text-foreground-900">文章不存在</h1>
            <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-600">
              返回首页
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const content = articleContentMap[article.id] || articleDefaultContent;
  const canonicalUrl = `/article/${article.id}`;
  const relatedArticles = articles
    .filter((a) => a.id !== article.id && a.categorySlug === article.categorySlug)
    .slice(0, 3);

  if (relatedArticles.length < 3) {
    const fillers = articles
      .filter((a) => a.id !== article.id && a.categorySlug !== article.categorySlug)
      .slice(0, 3 - relatedArticles.length);
    relatedArticles.push(...fillers);
  }

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    datePublished: article.publishedAt,
    author: {
      '@type': 'Organization',
      name: '黑料吃瓜网',
    },
    publisher: {
      '@type': 'Organization',
      name: '黑料吃瓜网',
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': canonicalUrl,
    },
  };

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: '/' },
      { '@type': 'ListItem', position: 2, name: article.category, item: `/category/${article.categorySlug}` },
      { '@type': 'ListItem', position: 3, name: article.title, item: canonicalUrl },
    ],
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: `${article.title}是真的吗？`,
        acceptedAnswer: {
          '@type': 'Answer',
          text: `本文内容来源于${article.source}，黑料吃瓜网对文中所述内容保持客观中立立场，请读者自行判断。`,
        },
      },
      {
        '@type': 'Question',
        name: '如何第一时间获取最新爆料？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以收藏黑料吃瓜网官网首页，或关注我们的社交媒体账号，我们将24小时不间断更新最新热点黑料和网红大瓜。',
        },
      },
    ],
  };

  return (
    <>
      <Head
        title={`${article.title} - 黑料吃瓜网`}
        description={`${article.excerpt} - 黑料吃瓜网独家追踪，第一时间获取最新八卦资讯。来源：${article.source}`}
        keywords={`${article.tags.join(',')},黑料吃瓜网,吃瓜网,${article.category}`}
        canonicalUrl={canonicalUrl}
        ogTitle={article.title}
        ogDescription={article.excerpt}
        ogType="article"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <Navbar />

      <main>
        <header className="pt-24 md:pt-28 pb-10 md:pb-14 bg-background-100">
          <div className="max-w-[800px] mx-auto px-4 md:px-8 text-center">
            <Link
              to={`/category/${article.categorySlug}`}
              className="inline-block text-xs font-medium text-primary-500 hover:text-primary-600 transition-colors"
            >
              {article.category}
            </Link>
            <h1 className="mt-4 text-2xl md:text-4xl font-heading text-foreground-950 leading-snug">
              {article.title}
            </h1>
            <div className="flex items-center justify-center gap-4 mt-4 text-xs text-foreground-500">
              <span>发布时间：{article.publishedAt}</span>
              <span className="w-1 h-1 bg-foreground-400 rounded-full"></span>
              <span>来源：{article.source}</span>
              <span className="w-1 h-1 bg-foreground-400 rounded-full"></span>
              <span className="flex items-center gap-1">
                <i className="ri-eye-line"></i>
                {article.views > 10000
                  ? `${(article.views / 10000).toFixed(1)}万阅读`
                  : `${article.views}阅读`}
              </span>
            </div>
          </div>
        </header>

        <nav className="bg-background-50 border-b border-background-200/60">
          <div className="max-w-[800px] mx-auto px-4 md:px-8 py-3">
            <div className="flex items-center gap-2 text-sm text-foreground-500">
              <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <Link to={`/category/${article.categorySlug}`} className="hover:text-primary-500 transition-colors">
                {article.category}
              </Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-700 truncate max-w-[200px]">{article.title}</span>
            </div>
          </div>
        </nav>

        <article className="py-10 md:py-14">
          <div className="max-w-[800px] mx-auto px-4 md:px-8">
            <div className="mb-10 rounded-lg overflow-hidden">
              <img
                src={articleDetailImages[article.id] || ''}
                alt={article.title}
                className="w-full h-auto max-h-[500px] object-cover"
              />
            </div>

            <div
              className="prose prose-lg max-w-none text-foreground-800 leading-relaxed space-y-4"
              dangerouslySetInnerHTML={{ __html: content }}
            />

            <div className="flex flex-wrap items-center gap-2 mt-10 pt-8 border-t border-background-200/60">
              <span className="text-sm font-medium text-foreground-600">标签：</span>
              {article.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 bg-background-100 text-foreground-600 text-xs rounded-full border border-background-200/60"
                >
                  #{tag}
                </span>
              ))}
            </div>
          </div>
        </article>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-[1280px] mx-auto px-4 md:px-8">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-8">
              相关爆料
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {relatedArticles.map((rel) => (
                <Link
                  key={rel.id}
                  to={`/article/${rel.id}`}
                  className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 transition-all duration-300 hover:scale-[1.02]"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={articleDetailImages[rel.id] || ''}
                      alt={rel.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                      loading="lazy"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-3 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
                        {rel.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-5">
                    <h3 className="text-base font-heading text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                      {rel.title}
                    </h3>
                    <div className="flex items-center justify-between mt-4">
                      <span className="text-xs text-foreground-500 flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {rel.views > 10000
                          ? `${(rel.views / 10000).toFixed(1)}万`
                          : rel.views}
                      </span>
                      <span className="text-xs text-foreground-400">{rel.publishedAt}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="relative w-full py-16 md:py-24 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20with%20notification%20alerts%20on%20screen%2C%20warm%20ambient%20lighting%2C%20dark%20background%2C%20news%20subscription%20concept%2C%20cinematic%20style%2C%20golden%20accent%20highlights%2C%20dramatic%20mood&width=1600&height=600&seq=cta-article-sub&orientation=landscape"
            alt="订阅防迷路"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/40"></div>
          <div className="relative max-w-[1280px] mx-auto px-4 md:px-8">
            <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
              <div>
                <h3 className="text-2xl md:text-3xl font-heading text-white">订阅防迷路</h3>
                <Link
                  to="/"
                  className="mt-6 inline-flex items-center gap-3 px-8 py-3.5 bg-white text-foreground-900 rounded-full text-sm font-medium hover:bg-foreground-50 transition-colors whitespace-nowrap"
                >
                  返回首页吃更多瓜
                  <span className="w-6 h-6 bg-foreground-950 rounded-full flex items-center justify-center">
                    <i className="ri-arrow-right-line text-white text-xs"></i>
                  </span>
                </Link>
              </div>
              <p className="text-white/80 text-base max-w-md leading-relaxed">
                收藏黑料吃瓜网，每天都有新鲜瓜等你来吃。记得分享给身边的朋友一起围观
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}